import { Button, EditIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type EditGroupButtonProps = {
  groupId: string;
};
export const EditGroupButton: React.FC<EditGroupButtonProps> = ({
  groupId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      key="group-edit"
      type="primary"
      icon={<EditIcon />}
      onClick={async () => {
        navigate(`/reporting/machine/groups/` + groupId);
      }}
      //loading={isLoading}
    >
      {t("reporting.machinestatus.manage_machine_group")}
    </Button>
  );
};
